import { mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { CellWarningIndicatorProps, WarningLevel } from './CellWarningIndicator.types';

export const Root = styled.div<StyledMods<Pick<CellWarningIndicatorProps, 'level'>>>`
    position: absolute;
    width: 5px;
    top: 4px;
    right: 0;
    bottom: 4px;

    ${mods('level', WarningLevel.Red)`
        background-color: ${theme.color.red70};
    `}

    ${mods('level', WarningLevel.Orange)`
        background-color: ${theme.color.brandAWX90};
    `}

    ${mods('level', WarningLevel.Yellow)`
        background-color: ${theme.color.brandDextMustard70};
    `}

    ${mods('level', WarningLevel.Black)`
        background-color: ${theme.color.midnight100};
    `}
`;
